import type { GroupBase, OptionProps } from "react-select";
import { components } from "react-select";

import { Select, SelectProps } from "@ui/Select";

type MeetingSubtypeDropdown = {
  value: string;
  label: string;
  icon?: React.ElementType;
  className?: string;
};

export function MeetingSubtypeSelect<T extends MeetingSubtypeDropdown>({
  ...rest
}: SelectProps<T, false>) {
  const CustomOption = (props: JSX.IntrinsicAttributes & OptionProps<T, false, GroupBase<T>>) => {
    return (
      <components.Option {...props}>
        <div className="flex items-center gap-2">
          {props.data.icon && <props.data.icon className={props.data.className} />}
          <p className="truncate text-sm font-medium">{props.data.label}</p>
        </div>
      </components.Option>
    );
  };

  return (
    <Select<T, false>
      {...rest}
      isMulti={false}
      isSearchable={false}
      components={{ Option: CustomOption, ...(rest.components || {}) }}
    />
  );
}
